import { web, mobile, backend, analysis, html, css, figma, git, redux, mongodb, tailwind, reactjs, nodejs, javascript, mov, mygithub, dashboard, vtu, real, ecomm, buildings, team } from '../assets'


export const navLink = [
    {
        id: "about",
        title: "About"
    },
    {
        id: "work",
        title: "Work"
    },
    {
        id: "portfolio",
        title: "Portfolio"
    },
    {
        id: "contact",
        title: "Contact"
    }
]

export const services = [
    {
        title: "Web Developer",
        icon: web,
    },
    {
        title: "Frontend Developer",
        icon: mobile,
    },
    {
        title: "Backend Developer",
        icon: backend,
    },
    {
        title: "Data analyst",
        icon: analysis,
    },
];

export const experiences = [
    {
        title: "Web Developer",
        company_name: "Punch Nigeria Limited",
        icon: buildings,
        iconBg: "#383E56",
        date: "2020 - Present",
        points: [
            "Developing and maintaining web applications using React.js and other related technologies.",
            "Conducted regular SEO audits and implemented improvements, resulting in a 30% increase in search engine rankings",
            "Implementing responsive design and ensuring cross-browser compatibility.",
            "Expedited actions to enhance the site's SEO, resulting in a 30% increase in website traffic from searches",
        ],
    },
    {
        title: "Junior Web Developer",
        company_name: "Gen 128 Business Solution",
        icon: team,
        iconBg: "#383E56",
        date: "2019 to 2020",
        points: [
            "Developed and maintained websites, implementing both front and back-end solutions for optimal functionality and user experience.",
            "Collaborated with marketing teams to align web development strategies with digital marketing goals.",
            "Demonstrated proficiency in Cpanels and hosting environments, ensuring seamless website deployment and management.",
        ],
    },
]

export const technologies = [
    {
        name: "HTML 5",
        icon: html,
    },
    {
        name: "CSS 3",
        icon: css,
    },
    {
        name: "JavaScript",
        icon: javascript,
    },
    {
        name: "React JS",
        icon: reactjs,
    },
    {
        name: "Redux Toolkit",
        icon: redux,
    },
    {
        name: "Tailwind CSS",
        icon: tailwind,
    },
    {
        name: "Node JS",
        icon: nodejs,
    },
    {
        name: "MongoDB",
        icon: mongodb,
    },
    {
        name: "git",
        icon: git,
    },
    {
        name: "figma",
        icon: figma,
    },

];

export const projects = [
    {
        name: 'Ecommerce Application',
        description: "E-commerce platform enabling seamless online shopping and order management for users, enhancing the digital retail experience.",
        tags: [
            {
                name: "react",
                color: 'blue-text-gradient'
            },

            {
                name: "mongoDb",
                color: 'pink-text-gradient',
            },

            {
                name: "restAPI",
                color: "green-text-gradient"
            }
        ],
        image: ecomm,
        link: "https://ecomm-nine-alpha.vercel.app/"
    },

    {
        name: 'VTU Web Application',
        description: "This is an Application where users can recharge Airtime, Databundle, CableTV subscription, Electricity Bill and more",
        tags: [
            {
                name: "react",
                color: 'blue-text-gradient'
            },

            {
                name: "mongoDb",
                color: 'pink-text-gradient',
            },

            {
                name: "restAPI",
                color: "green-text-gradient"
            }
        ],
        image: vtu,
        link: "https://vtu-brown.vercel.app/"
    },

    {
        name: 'Admin Dashboard',
        description: "This is an admin Dashboard with an interactive charts built with rechartJS, Tailwindcss, react. It's responsive on mobile",
        tags: [
            {
                name: "react",
                color: 'blue-text-gradient'
            },

            {
                name: "mongoDb",
                color: 'pink-text-gradient',
            },

            {
                name: "restAPI",
                color: "green-text-gradient"
            }
        ],
        image: dashboard,
        link: "https://admin-dashboard-one-omega.vercel.app/"
    },
    {
        name: 'Video Player App',
        description: "Web App that allows authenticated user to have access to movies, they can filter for movies based on genres and categories",
        tags: [
            {
                name: "react",
                color: 'blue-text-gradient'
            },

            {
                name: "mongoDb",
                color: 'pink-text-gradient',
            },

            {
                name: "restAPI",
                color: "green-text-gradient"
            }
        ],
        image: mov,
        link: "https://github.com/damydavo/video_player"
    },

    {
        name: 'Real Estate Market Place',
        description: "This is a real estate with an advance authentication and search functionality, user can create and update their own listings, ",
        tags: [
            {
                name: "react",
                color: 'blue-text-gradient'
            },

            {
                name: "mongoDb",
                color: 'pink-text-gradient',
            },

            {
                name: "restAPI",
                color: "green-text-gradient"
            }
        ],
        image: real,
        link: "https://github.com/damydavo/realtor"
    },

    {
        name: "Github Application",
        description: "React app for users to search and view personal GitHub data, including repos, followers, and latest contributions.",
        tags: [
            {
                name: "react",
                color: 'blue-text-gradient'
            },
            {
                name: "tailwindcss",
                color: "green-text-gradient"
            },
            {
                name: "github Api",
                color: "orange-text-gradient"
            }
        ],
        image: mygithub,
        link: "https://damydavo.github.io/Users_finder/"
    },
]